import React from 'react';
import ZeroCommentsEmptyState from '../../empty-states/zero-comments-empty-state';
import CommentingLockedEmptyState from '../../empty-states/commenting-locked-empty-state';
import RootCommentBox from '../comment-box/root-comment-box';
import { unreachable } from '../../../ts-utils';
import { StartRootBoxSectionSort } from './start-root-box-section-sort';
import { DummyCommentBox } from '../comment-box';
import { resolveSomeoneIsTyping } from './resolve-someone-is-typing';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { useApi } from '../../context/api-context/use-api';
import { getIsSSR } from '../../../common/store/base-params/base-params-selectors';
import { classes } from './start-root-box-section.st.css';
import { usePermissions } from '../../context/permissions-context/use-permissions';
export const StartRootBoxSectionComponent = ({ shouldShowCommentBox, hideSort, selectedSort, boxRating, isListEmpty, someoneIsTyping, }) => {
    const { hideZeroCommentsEmptyState, resourceId } = useConfiguration();
    const { loginRequiredDev, someoneIsTypingDev, isSSR, biAttemptLoginSignup, requestLoginAction } = useApi((state, actions, _, ctx) => ({
        loginRequiredDev: ctx.wcDevToolsState.specialStates === 'login_required',
        someoneIsTypingDev: ctx.wcDevToolsState.showSomeoneIsTyping,
        isSSR: getIsSSR(state),
        biAttemptLoginSignup: actions.biAttemptLoginSignup,
        requestLoginAction: actions.requestLogin,
    }));
    const { getPermission } = usePermissions();
    const addCommentPermission = getPermission({ action: 'CREATE_COMMENT' });
    const requestLogin = () => {
        biAttemptLoginSignup({ type: 'login', resourceId });
        requestLoginAction({ mode: 'login' });
    };
    if (loginRequiredDev) {
        return (React.createElement(React.Fragment, null,
            shouldShowCommentBox && (React.createElement(DummyCommentBox, { className: classes.commentBox, onClick: requestLogin })),
            React.createElement(StartRootBoxSectionSort, { hideSort: hideSort, selectedSort: selectedSort })));
    }
    if (addCommentPermission.type === 'ALLOW') {
        return (React.createElement(React.Fragment, null,
            shouldShowCommentBox ? (React.createElement(React.Fragment, null,
                React.createElement(RootCommentBox, { className: classes.commentBox, position: "start", shoudDispatchIAmTyping: addCommentPermission.precondition === 'NONE' ||
                        addCommentPermission.precondition === 'GUEST_FLOW', withGuestFlow: addCommentPermission.precondition === 'GUEST_FLOW', canRate: getPermission({ action: 'RATE' }).type === 'ALLOW', boxRating: boxRating }),
                React.createElement(StartRootBoxSectionSort, { hideSort: hideSort, selectedSort: selectedSort }),
                !isSSR && resolveSomeoneIsTyping('start', someoneIsTypingDev, someoneIsTyping),
                ' ',
                !shouldShowCommentBox && (React.createElement(StartRootBoxSectionSort, { hideSort: hideSort, selectedSort: selectedSort })))) : null,
            isListEmpty && !hideZeroCommentsEmptyState && React.createElement(ZeroCommentsEmptyState, null)));
    }
    switch (addCommentPermission.reason) {
        case 'LOCKED':
            return (React.createElement(React.Fragment, null,
                shouldShowCommentBox && (React.createElement("div", { className: classes.lockedState },
                    React.createElement(CommentingLockedEmptyState, null))),
                React.createElement(StartRootBoxSectionSort, { hideSort: hideSort, selectedSort: selectedSort })));
        case 'LOGIN_REQUIRED':
            return (React.createElement(React.Fragment, null,
                shouldShowCommentBox && (React.createElement(DummyCommentBox, { className: classes.commentBox, onClick: requestLogin })),
                React.createElement(StartRootBoxSectionSort, { hideSort: hideSort, selectedSort: selectedSort })));
        case 'UNKNOWN':
            return null;
        default:
            throw unreachable(addCommentPermission.reason);
    }
};
//# sourceMappingURL=start-root-box-section-component.js.map